import * as XLSX from "xlsx";
import { format, parseISO } from "date-fns";
import type { Task } from "@/services/task.service";
import type { Sprint } from "@/services/sprint.service";
import type { ColumnDef, ColumnCtx } from "./columns";

function formatSprintDate(date: string): string {
	return format(parseISO(date), "MMM d, yyyy");
}

function sanitizeForFilename(s: string): string {
	return s.replace(/[/\\:*?"<>|]/g, "-");
}

export function exportTaskReportsXlsx(
	tasks: Task[],
	columns: ColumnDef[],
	ctx: ColumnCtx,
	sprint: Sprint,
): void {
	const sprintLabel = `${sprint.name} (${formatSprintDate(sprint.start_date)} - ${formatSprintDate(sprint.end_date)})`;

	const aoa: (string | number)[][] = [];
	aoa.push([`Dev Task Reports [${sprintLabel}]`]);
	aoa.push([]);
	aoa.push(columns.map((c) => c.label));

	for (const t of tasks) {
		aoa.push(columns.map((c) => c.csv(t, ctx)));
	}

	const ws = XLSX.utils.aoa_to_sheet(aoa);
	ws["!cols"] = columns.map(() => ({ wch: 24 }));

	const wb = XLSX.utils.book_new();
	XLSX.utils.book_append_sheet(wb, ws, "Task Reports");

	const filename = `Dev Task Reports [${sanitizeForFilename(sprintLabel)}]`;
	XLSX.writeFile(wb, `${filename}.xlsx`);
}
